import * as React from "react";
import DataLoader from "components/DataLoader";
import { ProcessPaperLayout } from "../CustomPaperLayouts/ProcessPaperLayout";
import { getPlaceholderActionList } from "../Common/CommonProcessHelpers";
import { ProcessType } from "client/resources";

interface ProcessContextFormPageProps<TData> {
    title: string;
    processType: ProcessType;
    load(): Promise<TData>;
    renderWhenLoaded(data: TData): React.ReactNode;
}

export function ProcessContextFormPage<TData>() {
    const DataLoaderInternal = DataLoader<TData>();

    return class LoadInner extends React.Component<ProcessContextFormPageProps<TData>> {
        render() {
            return (
                <DataLoaderInternal
                    load={this.props.load}
                    renderWhenLoaded={this.props.renderWhenLoaded}
                    renderAlternate={({ errors, busy }) => <ProcessPaperLayout processType={this.props.processType} title={this.props.title} errors={errors} busy={busy} sectionControl={getPlaceholderActionList(this.props.processType)} />}
                />
            );
        }
    };
}
